import { Text } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ReportSkeleton } from '../../../../../../reports/elements/ReportSkeleton'
import { ReportTable } from '../../../../../elements/ReportTable'
import { TableHeader } from '../../../../../elements/TableHeader'
import { BALANCE_COLUMNS } from '../../constants/balanceColumns'
import { useTrialBalanceData } from '../../hooks/useTrialBalanceData'
import { TrialBalanceTableBody } from '../TrialBalanceTableBody'
import * as Styled from './styles'

export const TrialBalanceTable = (): ReactElement => {
  const { t } = useTranslation()
  const { allExpandableIds, reportData, isLoading } = useTrialBalanceData()

  if (isLoading || !allExpandableIds) {
    return (
      <ReportSkeleton
        headerChildren={
          <>
            {BALANCE_COLUMNS.map(({ key, label }) => (
              <Styled.HeaderCell key={key}>
                <Text weight="bold">{t(label)}</Text>
              </Styled.HeaderCell>
            ))}
          </>
        }
        columnWidths={[200, 120, 120, 120, 120]}
      />
    )
  }

  const header = (
    <TableHeader>
      {BALANCE_COLUMNS.map(({ key, label }) => (
        <Styled.HeaderCell key={key}>
          <Text weight="bold">{t(label)}</Text>
        </Styled.HeaderCell>
      ))}
    </TableHeader>
  )

  return (
    <ReportTable allExpandableIds={allExpandableIds} header={header}>
      <TrialBalanceTableBody reportData={reportData} />
    </ReportTable>
  )
}
